import { Dispute } from "./PaymentDispute";
import { PaymentIntent } from "./PaymentIntent";
import { PaymentMeta } from "./PaymentMeta";

export interface Payment {
    method: PaymentMethod | ID;
    card?: ID;
    transaction?: { id: ID };
    paymentIntent?: PaymentIntent;
    comment?: string;
    paymentIntentMethods?: ["card_present"];
    meta?: PaymentMeta;
    code?: string;
    token?: { id: ID };
    billingDetails?: StripeBillingDetails | AuthorizeNetBillingDetails;
    dispute?: Dispute;
    inputMethod?: CardInputMethod;
    last4?: string;
    remoteId?: string;
}

export enum CardInputMethod {
    SWIPE = "swipe",
    MANUAL = "manual",
}

export interface Card {
    last4?: string;
    token?: ID;
}

export enum PaymentMethod {
    AFFILIATE_DEPOSIT = "affiliate_deposit",
    ACH = "ACH", // Yes this method is actually all caps
    ach = "ach",
    CASH = "cash",
    CHECK = "check",
    CREDIT_CARD = "cc",
    INVOICE = "invoice",
    ELECTRONIC = "electronic",
    GIFT = "gift",
    LATER = "later",
    OTHER = "other",
    VOUCHER = "voucher",
    STORE_CREDIT = "store_credit",
    INTENT = "intent",
    PLUGIN = "plugin",
    CREDIT_LINE = "credit_line",
    XOLA_PAY = "xola_pay",
    WIRE = "wire",
    INTERNAL = "internal",
    KLARNA = "klarna",
    AFFIRM = "affirm",
    AFTERPAY = "afterpay_clearpay",
    ZIP = "zip",
}

export const PaymentMethodCopy: { [key in PaymentMethod]: string } = {
    [PaymentMethod.AFFILIATE_DEPOSIT]: "Partner Deposit",
    [PaymentMethod.ACH]: "ACH",
    [PaymentMethod.ach]: "ACH",
    [PaymentMethod.CASH]: "Cash",
    [PaymentMethod.CHECK]: "Check",
    [PaymentMethod.CREDIT_CARD]: "Credit Card",
    [PaymentMethod.INVOICE]: "Invoice",
    [PaymentMethod.ELECTRONIC]: "Electronic",
    [PaymentMethod.GIFT]: "Gift",
    [PaymentMethod.LATER]: "Later",
    [PaymentMethod.OTHER]: "Other",
    [PaymentMethod.VOUCHER]: "Voucher",
    [PaymentMethod.STORE_CREDIT]: "Store Credit",
    [PaymentMethod.INTENT]: "Intent",
    [PaymentMethod.PLUGIN]: "Plugin",
    [PaymentMethod.CREDIT_LINE]: "Credit Line",
    [PaymentMethod.XOLA_PAY]: "Xola Pay",
    [PaymentMethod.WIRE]: "Wire",
    [PaymentMethod.INTERNAL]: "Internal",
    [PaymentMethod.KLARNA]: "Klarna",
    [PaymentMethod.AFFIRM]: "Affirm",
    [PaymentMethod.AFTERPAY]: "Afterpay",
    [PaymentMethod.ZIP]: "Zip",
};

export interface StripeBillingDetails {
    name: string;
    email: string;
    address: { city: string; country: string; line1: string; line2: string; state: string };
}

export interface AuthorizeNetBillingDetails {
    firstName: string;
    lastName: string;
    address1: string;
    city: string;
    state: string;
    country: string;
}

export type BillingDetails = StripeBillingDetails | AuthorizeNetBillingDetails;
